import { Modal } from '../Common/Modal';
import { SkeletonLoader } from '../Common/SkeletonLoader';
import FooterSkeleton from './FooterSkeleton';

/**
 * Boot skeleton for `EmbeddedView`. Mirrors that view's single white column
 * so the swap to real content lands without a layout jump:
 * Unlike the DEFAULT skeleton there is no publisher hero band — EMBEDDED_VIEW
 * never paints one, so showing one here would flash a different shape for a
 * frame.
 */
const EmbeddedViewSkeleton = () => {
  return (
    <Modal>
      <div data-testid="embedded-view-skeleton" className="flex h-full w-full flex-col bg-white">
        <div className="flex min-h-0 flex-1 flex-col">
          <div className="flex flex-col pt-3">
            <div className="h-5 w-full" />
            <div className="mt-2">
              <SkeletonLoader height="h-20" />
            </div>
          </div>

          <div className="mt-4 w-full border-t border-base-border" />

          <div className="flex flex-col gap-5 pt-6 pb-5">
            <SkeletonLoader height="h-12" />
            <div className="flex items-center gap-3">
              <SkeletonLoader height="h-[2px]" />
              <SkeletonLoader width="w-40" height="h-5" />
              <SkeletonLoader height="h-[2px]" />
            </div>
            <div className="grid grid-cols-4 gap-3">
              <SkeletonLoader height="h-14" />
              <SkeletonLoader height="h-14" />
              <SkeletonLoader height="h-14" />
              <SkeletonLoader height="h-14" />
            </div>
            <SkeletonLoader height="h-10" />
            <div className="grid grid-cols-2 gap-3">
              <SkeletonLoader height="h-10" />
              <SkeletonLoader height="h-10" />
            </div>
            <SkeletonLoader height="h-10" />
          </div>
        </div>
        <FooterSkeleton />
      </div>
    </Modal>
  );
};

export default EmbeddedViewSkeleton;
